import React from "react";
import { Route, Routes } from "react-router-dom";
import ListPage from "../components/List/ListPage";
import MainPage from "../components/MainPage/MainPage";
import App from "../App";
import PreLogin from "./PreLogin";
import PostLogin from "./PostLogin";
import SignIn from "../components/Account/SignIn";
import ForgotPassword from "../components/Account/ForgotPassword";
import SignUp from "../components/Account/SignUp";
import VerifyEmail from "../components/Account/VerifyEmail";
import SetPassword from "../components/Account/SetPassword";
import SetupAccount from "../components/Account/SetupAccount";

export default function RootNavigation() {
  return <RootNavigator />;
}

function RootNavigator() {
  return (
    <>
      <Routes>
        {/* App wrapper layout */}
        <Route path="/" element={<App />}>
          {/* Pre-login routes */}
          <Route element={<PreLogin />}>
            {/* <Route  element={<SignIn />} /> */}
            <Route path="sign-in" element={<SignIn />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="sign-up" element={<SignUp />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="set-password" element={<SetPassword />} />
            <Route path="set-up-account" element={<SetupAccount />} />
          </Route>

          {/* Post-login routes */}
          <Route element={<PostLogin />}>
            <Route index path="/" element={<MainPage />}  />
            <Route path=":token" element={<MainPage />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}
